module.exports = __webpack_public_path__ + "img/2.449f943c.png";